import {Component, Input, OnInit} from '@angular/core';
import {DatePipe, NgClass, NgForOf, NgIf, NgOptimizedImage} from "@angular/common";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {Payout} from "../../../../../models/payout";
import {Router} from "@angular/router";
import {MatIcon} from "@angular/material/icon";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NgxIntlTelInputModule} from "@justin-s/ngx-intl-tel-input";
import {ReactiveFormsModule} from "@angular/forms";

@Component({
  selector: 'app-housing-certificate-card',
  standalone: true,
  imports: [
    DatePipe,
    NgForOf,
    NgIf,
    NgOptimizedImage,
    TranslateModule,
    NgClass,
    MatIcon,
    NgxIntlTelInputModule,
    ReactiveFormsModule
  ],
  templateUrl: './housing-certificate-card.component.html',
  styleUrl: './housing-certificate-card.component.scss'
})
export class HousingCertificateCardComponent implements OnInit {

  @Input() public certificate: any;
  @Input() public showButton: any;
  public locale = 'en';
  text = {
    title:'',
    text:'',
    subtitle:null,
  }
  contactFormUrl = 'https://form.typeform.com/to/Skse0ywG';

  constructor(
    private router: Router,
    private _translateService: TranslateService,
    private ngbModal: NgbModal
  ) {
  }

  ngOnInit() {
    this.locale = this._translateService.currentLang;
    this.setHCDatas();
    if (this.locale === 'fr') {
      this.contactFormUrl = 'https://form.typeform.com/to/vfP7UpuV';
    }
  }

  public goToHousingCertificate(certificate: Payout): void {
    let url = this.locale + '/housing-certificate/';
    switch (certificate.status) {
      case 'Expired': {
        url += 'expired';
        break;
      }
      case 'Accepted':
      case 'Canceled': {
        url += 'post-payment';
        break;
      }
      case 'Pending-refund': {
        url += 'pending';
        break;
      }
      default: {
        url += certificate.status.toLowerCase();
      }
    }

    this.router.navigate([url]);
  }


  private setHCDatas(): void {
    if (this.certificate.datas) {
      const info = JSON.parse(this.certificate.datas);
      if (info.address) {
        const split = info.address.split(' ');
        if (split && split.length > 0) {
          this.certificate.city = split[split.length - 1];
        }
      }
    }
    const today = new Date();
    const createdDate = new Date(this.certificate.created_at);
    const targetDate = new Date('2024-07-16');
    let expirationDate: Date;

    if (createdDate < targetDate) {
      expirationDate = new Date(createdDate.getFullYear(), createdDate.getMonth() + 2, createdDate.getDate() + 2);
    } else {
      expirationDate = new Date(createdDate.getFullYear(), createdDate.getMonth() + 1, createdDate.getDate() + 1);
    }

    if (today.getTime() >= expirationDate.getTime()) {
      if (this.certificate.status === 'Accepted' || this.certificate.status === 'Canceled' || this.certificate.status === 'Not-refunded') {
        this.certificate.status = 'Expired';
      }
    }
    if (this.certificate.refundDatas && typeof this.certificate.refundDatas === "string") {
      const datas = JSON.parse(this.certificate.refundDatas);
      this.certificate.refundDatas = datas;
      if (datas.reason) {
        this.setRefusalText('NOT_REFUNDED_' + datas.reason);
      } else {
        this.setRefusalText('NOT-REFUNDED');
      }
    }
  }

  openModal(modale): void {
    this.ngbModal.open(modale, {size:"sm", centered:true});
  }

  private setRefusalText(reason): void {
    this.text.title = 'PROCESSES.HOUSING_CERTIFICATE.' + reason.toUpperCase() + '.TITLE';
    if (reason !== 'NOT_REFUNDED_EXPIRED' && reason != 'NOT_REFUNDED_FALSE_DOCUMENT') {
      this.text.subtitle = 'PROCESSES.HOUSING_CERTIFICATE.' + reason.toUpperCase() + '.SUBTITLE';
    }
    this.text.text = 'PROCESSES.HOUSING_CERTIFICATE.' + reason.toUpperCase() + '.TEXT';
  }
}
